export default "__VITE_ASSET__INg7GV1u__"